// extracted by mini-css-extract-plugin
export default {"root":"TherapistStep3_1_root__Hx047","addButton":"TherapistStep3_1_addButton__h118N","item":"TherapistStep3_1_item__e1wC6","hint":"TherapistStep3_1_hint__P7Uab"};